import React from 'react'
import styled from 'styled-components'
import Card from 'core-system/Card'

const MainContainer = styled(Card)`
  margin-bottom: 1.5rem;
  margin-top: 0 !important;
`

const Box = ({
  children,
  style,
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  return <MainContainer style={style}>{children}</MainContainer>
}

export default Box
